module.exports = __webpack_public_path__ + "static/media/s16.b5ca8eaa.png";